import { useAuthState } from "_ReactContext/AuthContext";
import { useApiCache } from "customHooks/useApi";

export function useApproverCustomList(
    t: any
): [Compleo.CustomLists.ListDefinitionType[], boolean] {
    const { company } = useAuthState();

    const [listResult] = useApiCache(
        "/user/getuserandcontactlist",
        "post",
        {
            companyId: company.companyId,
            customerFilterIdList: []
        },
        false,
        60 * 1000 * 10
    );
    const userList = listResult.response?.data || [];
    const list: Compleo.CustomLists.ListDefinitionType[] = [
        {
            data: userList.map((item: any) => {
                const type = t(item?.type.toLowerCase());
                return {
                    value: item.email,
                    label: `${item.name} - (${type})`
                };
            }),
            fieldName: "internalApprovers",
            labelName: "label",
            valueName: "value"
        }
    ];
    const approvalLogicList: Compleo.CustomLists.ListDefinitionType = {
        fieldName: "approvalLogic",
        data: ["and", "or"].map((value) => ({
            itemValue: value,
            itemText: t(`approvalLogicList_${value}`)
        })),
        valueName: "itemValue",
        labelName: "itemText"
    };
    list.push(approvalLogicList);
    const ready = listResult.status === "success";

    return [list, ready];
}
